import axios from "axios";
import { API_BASE_URL } from "../configs/AppConfig";
import store from "../redux/store";
import {
  // API_DISPLAY_RESPONSE_MESSAGE,
  MESSAGE_TYPE,
} from "redux/constants/ApiMessageResponse";
import { apiResponseMessage } from "redux/actions/ApiMessageResponse";
import { signOut } from "redux/actions/Auth";
import { END_POINTS } from "constants/APIConstant";

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000,
});
// Config
// const ENTRY_ROUTE = "/Auth/Login";
const TOKEN_PAYLOAD_KEY = "authorization";
const LOCALE_PAYLOAD_KEY = "locale";
const PUBLIC_REQUEST_KEY = "public-request";

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    config.headers[LOCALE_PAYLOAD_KEY] = store.getState().theme.locale;
    const jwtToken = store.getState().auth.token;
    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = jwtToken;
    }

    if (!jwtToken && !config.headers[PUBLIC_REQUEST_KEY]) {
      //Disable the coming line until adding authorization
      //history.push(ENTRY_ROUTE);
    }
    return config;
  },
  (error) => {
    // Do something with request error here
    // notification.error({
    //   message: "Error",
    // });
    Promise.reject(error);
  }
);

// API response interceptor
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    let message = "";
    if (error.response.status === 400 || error.response.status === 403) {
      if (error.response.data && error.response.data.message) {
        message = error.response.data.message;
      } else {
        message = "Not Found";
      }
    }

    if (error.response.status === 401) {
      store.dispatch(signOut());
      MutateCacheSWRPartialKey(END_POINTS.GET_USER_DATA);
    }

    if (error.response.status === 404) {
      message = "Not Found";
    }

    if (error.response.status === 500) {
      message = "Internal Server Error";
    }

    if (error.response.status === 508) {
      message = "Time Out";
    }

    store.dispatch(
      apiResponseMessage({
        showMessage: true,
        message: message,
        messageType: MESSAGE_TYPE.ERROR,
      })
    );

    return Promise.reject(error);
  }
);

export default service;
